import {formatQualificationDateToPqe} from '../../shared/services/format-pqe'

const recommendationsController = (
  $scope,
  usSpinnerService,
  RecommendationsApi,
  locationsGenericService,
  practiceAreaService,
  CandidateProfileApi,
  socket,
  $timeout
) => {
  socket.on('CANDIDATE_RECOMMENDATION_GENERATED', async candidateId => {
    $timeout(async () => {
      if ($scope.candidate.id === candidateId) {
        await $scope.getRecommendation()
      }
    }, 1500)
  })

  $scope.recommendationsPageChange = _.debounce(() => {
    console.debug('recommendations page change')
    options.sortBy = $scope.sortBy
    options.limit = $scope.paginationOptions.selectedLimit
    options.page = $scope.pagination.currentPage
    options.positionTypes = $scope.positionTypes
    $scope.getRecommendation()
  }, 20)

  $scope.initializeRecommendations = async () => {
    // $scope.recommendationsLoading = true
    $scope.sliderOptions = {
      experience: {
        round: 1,
        from: -2,
        to: 11,
        step: 0.5,
        dimension: '+ years',
        scale: [-2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, '11+'],
      },
      selectivity: {
        round: 1,
        from: 1,
        to: 6,
        step: 1,
        dimension: '$',
        scale: ['$', '$$', '$$$', '$$$$', '$$$$$', '$$$$$$'],
      },
    }

    // eslint-disable-next-line no-negated-condition
    if (!$scope.sortBy) {
      console.debug('$scope.positionTypes', $scope.positionTypes)
      const positionTypesLower = new Set(
        $scope.positionTypes.map(x => x.toLowerCase())
      )
      const isRegularCustomTab =
        positionTypesLower.has('regular') && positionTypesLower.has('custom')
      $scope.sortBy = isRegularCustomTab ? 'recency' : 'alphabetical'
    } else {
      console.debug(
        'not touching $scope.sortBy. current value is',
        $scope.sortBy
      )
    }

    $scope.uncategorizedSelectivity = true

    $scope.candidatePqe = formatQualificationDateToPqe(
      $scope.candidate.lawProfile.qualificationDate
    )

    $scope.candidateMinPqe =
      $scope.candidatePqe <= -1 ? -2 : $scope.candidatePqe - 1
    $scope.candidateMaxPqe =
      $scope.candidatePqe >= 10 ? 11 : $scope.candidatePqe + 1

    $scope.sliderFilter = {
      selectivity: '1;6',
      experience: `${$scope.candidateMinPqe};${$scope.candidateMaxPqe}`,
    }

    $scope.paginationOptions = {
      limitOptions: [10, 25, 50, 100],
      selectedLimit: 50,
    }

    $scope.pagination = {
      currentPage: 1,
      totalItems: 0,
    }

    if (!$scope.preferredLocation) {
      const {data} = await CandidateProfileApi.getUserProfile(
        $scope.candidate.id,
        {
          include: ['preferredLocations'],
        }
      )

      $scope.candidate.preferredLocations = data.preferredLocations
    }

    $scope.filterData = {
      regionHierarchialListWithEuropeOnTop: locationsGenericService.makeCandidateLocationsHierarchy(
        $scope.candidate.preferredLocations,
        $scope.locations
      ),
      locations: angular.copy($scope.candidate.preferredLocations),
      candidateSpecialties: practiceAreaService.makeCandidatePracticeAreasHierarchy(
        $scope.candidate.category,
        $scope.legalPracticeAreas
      ),
      employerTypes: $scope.employerTypes.map(employerType =>
        Object.assign({ticked: true}, employerType)
      ),
      contracts: $scope.contracts.map(contract =>
        Object.assign({ticked: true}, contract)
      ),
      occupations: $scope.occupations.map(occupation =>
        Object.assign({ticked: true}, occupation)
      ),
    }

    $scope.recommendationsPageChange($scope.sortBy)
  }

  $scope.initializeRecommendations()

  const refreshRecommendations = (event, tab) => {
    console.debug('recommendationsController.refreshRecommendations', tab)
    // $scope.recommendationsLoading = true
    $scope.recommendations = []
    const isRecommendationsTab =
      tab === 'recommendations/showRegularCustom' ||
      tab === 'recommendations/showSpecConnect'
    if (isRecommendationsTab) {
      switch (tab) {
        case 'recommendations/showRegularCustom':
          $scope.sortBy = 'recency'
          break
        case 'recommendations/showSpecConnect':
          $scope.sortBy = 'alphabetical'
          break
        default:
          break
      }

      $scope.recommendationsPageChange($scope.sortBy)
    } else {
      console.log('not recommendations tab')
    }
  }

  $scope.$on('tab:change', refreshRecommendations)
  $scope.$on(`candidate:updated`, refreshRecommendations)

  $scope.applySort = () => {
    options.sortBy = $scope.sortBy
    $scope.recommendationsPageChange($scope.sortBy)
  }

  const options = {
    limit: $scope.paginationOptions.selectedLimit,
    page: $scope.pagination.currentPage,
    positionTypes: $scope.positionTypes,
    minPqe: $scope.candidateMinPqe,
    maxPqe: $scope.candidateMaxPqe,
  }
  $scope.getRecommendation = async () => {
    usSpinnerService.spin('spinner-recommendations')
    console.debug('$scope.getRecommendation START', options)
    const {
      data: recommendations,
    } = await RecommendationsApi.getCandidateRecommendations(
      $scope.candidate.id,
      options
    )
    console.debug('getRecommendations::recommendations', recommendations)

    $scope.recommendations = recommendations.positions
    if ($scope.sortBy === 'alphabetical') {
      $scope.recommendations = _.sortBy(
        $scope.recommendations,
        recommendation => {
          return recommendation.employer.name.toLowerCase()
        }
      )
    }

    $scope.count = recommendations.positionsCount.totalPositions
    $scope.pagination.totalItems = recommendations.positionsCount.totalPositions
    formatRecommendations($scope.recommendations)
    usSpinnerService.stop('spinner-recommendations')
    console.debug('$scope.getRecommendation STOP')
    $scope.$applyAsync()
  }

  const formatRecommendations = recommendations => {
    recommendations.forEach(recommendation => {
      if (recommendation.employer.logo)
        recommendation.employer.logoSrc = `${process.env.PUBLIC_BUCKET_URL}/employers/${recommendation.employerId}/logo/${recommendation.employer.logo}`
      else recommendation.employer.logoSrc = `images/firm-logo-default.jpg`
      recommendation.locations = recommendation.locations.map(location =>
        $scope.locations.find(loc => location.id === loc.id)
      )
      recommendation.legalPracticeAreas = recommendation.practiceAreas.map(
        practice =>
          $scope.legalPracticeAreas.find(
            legalPractice => practice.id === legalPractice.id
          )
      )
      recommendation.contract = $scope.contracts.find(
        contract => contract.id === recommendation.contractTypeId
      )
      recommendation.occupation = $scope.occupations.find(
        occupation => occupation.id === recommendation.occupationId
      )
    })
  }

  $scope.expandPosition = position => {
    position.expanded = !position.expanded
  }

  $scope.onChangePracticeArea = (event, selectedPracticeArea) => {
    options.practiceAreas = selectedPracticeArea.map(practice => practice.id)
    $scope.getRecommendation()
  }

  $scope.onChangeLocation = (event, selectedLocations) => {
    options.locations = selectedLocations.map(location => location.id)
    $scope.getRecommendation()
  }

  $scope.applyFilter = type => {
    switch (type) {
      case 'experience':
        // eslint-disable-next-line no-case-declarations
        const experience = $scope.sliderFilter.experience.split(';')
        options.minPqe = Number(experience[0])
        options.maxPqe = Number(experience[1])
        $scope.getRecommendation()
        break
      case 'selectivity':
        // eslint-disable-next-line no-case-declarations
        const selectivity = $scope.sliderFilter.selectivity.split(';')
        options.minSelectivity = Number(selectivity[0])
        options.maxSelectivity = Number(selectivity[1])
        options.uncategorizedSelectivity = $scope.uncategorizedSelectivity
        $scope.getRecommendation()
        break
      case 'employerType':
        options.employerTypes = $scope.filterData.employerTypes
          .filter(employerType => employerType.ticked)
          .map(employerType => employerType.id)
        $scope.getRecommendation()
        break
      case 'occupation':
        options.occupations = $scope.filterData.occupations
          .filter(occupation => occupation.ticked)
          .map(occupation => occupation.id)
        $scope.getRecommendation()
        break
      case 'contract':
        options.contractTypes = $scope.filterData.contracts
          .filter(contract => contract.ticked)
          .map(contract => contract.id)
        $scope.getRecommendation()
        break
      default:
        break
    }
  }

  $scope.unHidePosition = async position => {
    if (position.positionHidden) {
      const payload = {
        positionIds: [position.id],
        hide: false,
        reason: ' ',
      }
      await RecommendationsApi.unHideCandidatePosition(
        $scope.candidate.id,
        payload
      )
      position.positionHidden = false
    }

    if (position.employerHidden) {
      const payload = {
        employerIds: [position.employerId],
        updateValue: false,
      }
      await RecommendationsApi.unHideCandidateEmployer(
        $scope.candidate.id,
        payload
      )
      position.employerHidden = false
    }

    $scope.$apply()
  }

  $scope.hideRecommendation = (position, type) => {
    position[`${type}Hidden`] = true
    $scope.$apply()
  }
}

export {recommendationsController}



// WEBPACK FOOTER //
// ./scripts/candidate-profile/recommendations/recommendations.ctrl.js